import { ActionTypes } from "planning-portal-library/src/lib/core/domain/enums/action-types";
import { Service } from "planning-portal-library/src/lib/core/domain/models/service";
import { Mapper } from "../../../../../core/base";
import { ServiceWebEntity } from "./service-web-entity";
import { DateTime } from "luxon";

export class ServiceWebRepositoryMapper extends Mapper<
  ServiceWebEntity,
  Service
> {
  mapFrom(param: ServiceWebEntity): Service {
    return {
      id: param.id,
      objectType: param.objectType,
      action: ActionTypes[Number(param.action)],
      size: param.size,
      weight: param.weight,
      tenantId: param.tenantId,
      locationId: param.locationId,
      locationName: param.locationName,
      createdAt: DateTime.fromISO(param.createdAt ?? ""),
      customData: param.customData
    };
  }

  mapTo(param: Service): ServiceWebEntity {
    return {
      id: param.id,
      objectType: param.objectType,
      action: param.action,
      size: param.size,
      weight: param.weight,
      tenantId: param.tenantId,
      locationId: param.locationId,
      locationName: param.locationName,
      createdAt: param.createdAt.toISO(),
      customData: param.customData
    };
  }
}
